import React, { Component } from "react";
import { withRouter } from "react-router";

import logo from './assets/logo192.png'; // Tell Webpack this JS file uses this image


import { Route, Switch, Link } from "react-router-dom";

import "./sass/Dashboard.scss";
import { Layout, Menu } from "antd";
import {
  LogoutOutlined
} from "@ant-design/icons";

import ClienteList from "../components/Clients/ClienteList";
import Transazioni from "../components/Transazioni";
import Notifications from "../components/Notifications";

import Negozi from "./Negozi/Negozi";
import AnalyticsTabs from "./Analytics/AnalyticsTabs";
import OfferteContainer from "./Offerte/OfferteContainer";
import RicetteContainer from "./Ricette/RicetteContainer";


const { Content, Sider } = Layout;

class Dashboard extends Component {
  // fetch a list of them and show them here

  constructor(props) {
    super(props);

    console.log(props.location.pathname)

    this.state = {
      current: "",
      initialKey: props.location.pathname
    };

    this.LogOut = this.LogOut.bind(this);
  }

  componentDidMount() {
    // redirect if you don't even have an access token or a refresh_token

    if (localStorage.getItem("access_token") === null) {
      this.props.history.push("/");
    }

    // check if you first have an access_token in the local_storage, if not redirect back to login
  }

  handleClick = (e) => {
    console.log("click ", e);
    this.setState({
      current: e.key,
    });
  };

  LogOut() {
    console.log("logout");

    // clear storage and redirect to login page

    localStorage.clear();
    this.props.history.push(`/`);
  }


  // if the role is admin render the AdminMenu component

  // otherwise render the ShopMenu component


  renderContent() {
    return (
      <Switch>
        <Route path="/dashboard/clienti">
          <ClienteList role={this.props.role} negozio={this.props.username} />
        </Route>

        {/* <Route path="/dashboard/transazioni/:id">
          <NotFound />
        </Route> */}

        <Route path="/dashboard/transazioni">
          <Transazioni role={this.props.role} />
        </Route>

        <Route path="/dashboard/offerte">
          <OfferteContainer />
        </Route>
        <Route path="/dashboard/Ricette">
          <RicetteContainer />
        </Route>
        <Route path="/dashboard/Notifiche">
          <Notifications />
        </Route>

        <Route path="/dashboard/Negozi">
          <Negozi />
        </Route>

        <Route path="/dashboard/analytics">
          <AnalyticsTabs />
        </Route>

        <Route>
          <ClienteList negozio={this.props.username} />
        </Route>
      </Switch>)
  }

  render() {
    return (
      <Layout>
        <Sider
          width={200}
          style={{ overflow: 'auto', height: '100vh', position: 'sticky', top: 0, left: 0, }}
        >

          <Menu
            direction="vertical"
            theme="dark"
            defaultSelectedKeys={[this.state.initialKey]}
            onClick={this.handleClick}
          >
            <Menu.Item key="/root">  <img src={logo} height="40px" width="40px" alt="" />  {this.props.username} </Menu.Item>
            <Menu.Item key="/dashboard/clienti"> <Link to="/dashboard/clienti">Clienti</Link> </Menu.Item>
            <Menu.Item key="/dashboard/transazioni"> <Link to="/dashboard/transazioni">Transazioni</Link> </Menu.Item>

            {this.props.role === 'admin' &&
              <Menu.Item key="/dashboard/ricette"> <Link to="/dashboard/ricette">Ricette</Link> </Menu.Item>
            }

            {this.props.role === 'admin' &&
              <Menu.Item key="/dashboard/offerte"> <Link to="/dashboard/offerte">Offerte</Link> </Menu.Item>
            }

            {this.props.role === 'admin' &&
              <Menu.Item key="/dashboard/notifiche"> <Link to="/dashboard/notifiche">Notifications</Link> </Menu.Item>
            }

            {this.props.role === 'admin' &&
              <Menu.Item key="/dashboard/negozi"> <Link to="/dashboard/negozi">Negozi</Link> </Menu.Item>
            }

              <Menu.Item key="/dashboard/analytics"> <Link to="/dashboard/analytics">Dati</Link> </Menu.Item>

            <Menu.Item key="logout" onClick={this.LogOut}>
              <LogoutOutlined />
                        Esci
                </Menu.Item>
          </Menu>

        </Sider>
        <Layout>
          <Content style={{ overflow: "initial" }}>
            {this.renderContent()}
          </Content>
        </Layout>

      </Layout>

    );
  }
}

export default Dashboard = withRouter(Dashboard);
